export const catalogConfigs = {
  title: {
    default: "APM Technologies",
    ko: "에이피엠테크놀로지스 전자카탈로그",
  },
  langSet: ["en"],
  pageMap: [
    { name: "cover", outlets: ["scene1", "scene2", "scene3", "scene4"] },
    { name: "index" },
    { name: "intro" },
    { name: "about" },
    { name: "history" },
    { name: "business" },
    { name: "valuedClients" },
    { name: "globalNetwork" },
    { name: "products", outlets: ["content1", "content2"] },
    { name: "lineup" },
    { name: "apm7000" },
    { name: "apm7000P" },
    { name: "apm5000" },
    { name: "apm3000" },
    { name: "apm2000" },
    { name: "apm1200" },
    { name: "sensor", outlets: ["internal", "external", "noise", "drain-valve", "HFCT"] },
    { name: "pd-diagnostic" },
    { name: "available" },
    { name: "service-cases" },
    { name: "end" },
  ],
  autoplay: false,
  width: 1920,
  height: 1080,
  breakpoint: 767,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
